import { ChangeDetectionStrategy, Component, inject, Input, Signal, ViewChild, WritableSignal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { FormControlComponent } from '../../../../shared/components/form-control/form-control.component';
import { BaseModalComponent } from '../../../../core/layout/components/abstracts/base-modal.component';
import {
  TerminalTseDetailsModalComponent
} from '../../../fiskaly/modals/terminal-tse-details-modal/terminal-tse-details-modal.component';
import { EcTerminalActionsModalComponent } from '../ec-terminal-actions-modal/ec-terminal-actions-modal.component';
import { CustomerScreenService } from '../../../../core/services/CustomerScreenService';
import { TooltipDirective } from '../../../../shared/directives/tooltip.directive';
import { environment } from '../../../../../environments/environment';
import { SumUpDevReader } from '../../../terminals/core/sumup-dev-reader';
import { TerminalsService } from '../../../terminals/core/services/TerminalsService';

@Component({
  selector: 'app-extras-modal',
  standalone: true,
  imports: [
    TranslatePipe,
    ModalComponent,
    TerminalTseDetailsModalComponent,
    EcTerminalActionsModalComponent,
    TooltipDirective,
    FormControlComponent,
    FormsModule,
  ],
  templateUrl: './extras-modal.component.html',
  styleUrl: './extras-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExtrasModalComponent extends BaseModalComponent {

  @Input({ required: true }) isCustomerScreenOnline: WritableSignal<boolean>;
  @Input({ required: true }) workerStatusColorClass: Signal<string>;

  @ViewChild('sumUpPairingModal') sumUpPairingModal: ModalComponent;

  public readonly sumUpDevReader = environment.sumUpDevReader;
  public sumUpPairingCode = '';
  public sumUpReaderId = '';

  private readonly _customerScreenService = inject(CustomerScreenService);
  private readonly _terminalsService = inject(TerminalsService);

  public openSumUpPairing(): void {
    this.sumUpPairingCode = SumUpDevReader.pairingCode();
    this.sumUpReaderId = SumUpDevReader.readerId();
    this.sumUpPairingModal.open();
  }

  public confirmSumUpPairing(): void {
    const code = this.sumUpPairingCode?.trim();
    if (!code) {
      return;
    }

    this._terminalsService.pairSumUpReader(code).subscribe({
      next: (res) => {
        SumUpDevReader.rememberReader(res.data.readerId);
        this.sumUpReaderId = res.data.readerId;
        this.sumUpPairingModal.close();
      },
      error: () => {
        this.notificationService.pushError(
          'Fehler'.trans('notifications/error.Title'),
          'SumUp hat den Kopplungscode abgelehnt.'.trans('extras/extras-modal/sumup-pairing/rejected.Message')
        );
        this.cdr.markForCheck();
      }
    });
  }

  public toggleCustomerScreen(): void {
    this.isCustomerScreenOnline()
      ? this._customerScreenService.closeCustomerScreen()
      : this._customerScreenService.openCustomerScreen();
  }
}
